import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { Menu, X, TreePine, User } from 'lucide-react';

const Header = () => {
  const { isAuthenticated, user } = useAuth();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'About', href: '#about' },
    { name: 'Gallery', href: '#gallery' },
    { name: 'Activities', href: '#activities' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-stone-900/95 backdrop-blur-md shadow-lg py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex items-center gap-2 group">
          <TreePine className="w-8 h-8 text-emerald-400 group-hover:scale-110 transition-transform duration-300" />
          <span className="text-xl font-semibold text-white tracking-wide">
            Stay <span className="text-emerald-400">Tran-Quil</span>
          </span>
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="text-stone-200 hover:text-emerald-400 transition-colors duration-300 text-sm font-medium tracking-wide"
            >
              {link.name}
            </a>
          ))}
          {isAuthenticated ? (
            <Link to="/dashboard">
              <Button className="bg-emerald-600 hover:bg-emerald-500 text-white px-6 py-2 rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-emerald-500/25">
                <User className="w-4 h-4 mr-2" />
                Dashboard
              </Button>
            </Link>
          ) : (
            <Link to="/book">
              <Button className="bg-emerald-600 hover:bg-emerald-500 text-white px-6 py-2 rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-emerald-500/25">
                Book Now
              </Button>
            </Link>
          )}
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-full left-0 right-0 bg-stone-900/98 backdrop-blur-md transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen ? 'max-h-96 border-b border-stone-700' : 'max-h-0'
        }`}
      >
        <nav className="flex flex-col p-6 gap-4">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-stone-200 hover:text-emerald-400 transition-colors duration-300 text-lg font-medium py-2"
            >
              {link.name}
            </a>
          ))}
          <Button
            asChild
            className="bg-emerald-600 hover:bg-emerald-500 text-white mt-2 rounded-full"
          >
            <Link to="/book" onClick={() => setIsMobileMenuOpen(false)}>
              Book Your Stay
            </Link>
          </Button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
